import JSONbig from 'json-bigint'
import { API_BASE } from './config.js'

const jsonParser = JSONbig({ storeAsString: true })

function getToken() {
  return localStorage.getItem('token') || ''
}

function request(method, path, body) {
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + getToken()
  }
  const options = {
    method,
    headers,
    credentials: 'include'
  }
  if (body !== undefined) {
    options.body = JSON.stringify(body)
  }
  return fetch(`${API_BASE}${path}`, options)
    .then(res => res.text())
    .then(text => jsonParser.parse(text))
}

/**
 * 创建项目
 * @param {Object} params
 * @param {number} params.workspaceId 所属工作区 ID
 * @param {string} params.name 项目名称
 * @param {string} [params.icon] 项目图标
 * @param {string} [params.color] 项目颜色（#RRGGBB）
 * @param {string} [params.description] 项目描述
 * @returns {Promise<{code:number,message:string,data:Object,success:boolean,timestamp:string}>}
 */
export function createProject(params) {
  return request('POST', '/api/v1/projects', params)
}

/**
 * 查询指定工作区下的项目列表
 * @param {number} workspaceId 工作区 ID
 * @returns {Promise<{code:number,message:string,data:Array,success:boolean,timestamp:string}>}
 */
export function listProjects(workspaceId) {
  return request('GET', `/api/v1/projects?workspaceId=${workspaceId}`)
}

/**
 * 更新项目
 * @param {number} id 项目 ID
 * @param {Object} params
 * @param {string} [params.name] 项目名称
 * @param {string} [params.icon] 项目图标
 * @param {string} [params.color] 项目颜色（#RRGGBB）
 * @param {string} [params.description] 项目描述
 * @returns {Promise<{code:number,message:string,data:Object,success:boolean,timestamp:string}>}
 */
export function updateProject(id, params) {
  return request('PUT', `/api/v1/projects/${id}`, params)
}

/**
 * 删除项目
 * @param {number} id 项目 ID
 * @returns {Promise<{code:number,message:string,data:null,success:boolean,timestamp:string}>}
 */
export function deleteProject(id) {
  return request('DELETE', `/api/v1/projects/${id}`)
}
